import { render } from "./Addchefquartier.vue?vue&type=template&id=650b9cc5&ts=true"
import script from "./Addchefquartier.vue?vue&type=script&lang=ts"
export * from "./Addchefquartier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__